exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".info-box[data-v-260c38d2] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #ffffff;\n  border: 1px solid #000000;\n  display: inline-block;\n  padding: 0.5rem;\n  box-sizing: border-box;\n  z-index: 4;\n}\n", ""]);

